import { Component, OnInit, Input } from '@angular/core';
import { DataType } from './data-type-enums.model';

@Component({
    selector: 'eig-detail-table',
    templateUrl: './eig-detail-table.component.html',
    styleUrls: ['./eig-detail-table.component.scss'],
})
export class EigDetailTableComponent {
    readonly dataType = DataType;

    @Input()
    detailData: any;

    @Input()
    detailHeader: string;

    keyDoNotAllowRenderViewContent(key: string) {
        const keys = ['gateway.label.sandbox', 'gateway.label.notification_enabled'];
        return keys.includes(key);
    }

    keyDoNotRenderRowView(key: string) {
        const keys = ['gateway.label.deposit', 'gateway.label.withdrawal'];
        return keys.includes(key);
    }
}
